export const defaultColumns = [
  { label: 'Tipo', value: 'role', className: 'w-10' },
  { label: 'Nome', value: 'fullName' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
]
